import { fetchTicketsByJQL } from "../redux/action/jiraAction";

export const JiraDataSourceHarvesting = async ({ dbRows, jql, selectedFields,columns, dispatch }) => {
  let sourceDetails = {type: 'JIRA'};
  let params = {
    "selectedFields": selectedFields,
    "jql": jql
  }
  let {issues,issueObj} = await dispatch(fetchTicketsByJQL(sourceDetails, params))
  let colMap={}
  columns && columns.forEach((col) => {
      colMap[col.headerName?.toLowerCase()]=col.columnType
  })
  let formattedRows=[]
  dbRows.forEach((row) => {
    if(issueObj[row.id]){
      const currRow = {...row };
      Object.keys(row).forEach((gridField) => {
        if (typeof row[gridField] === "object" && row[gridField] && !Array.isArray(row[gridField])) {
          const fieldName = row[gridField].field;
          if(fieldName && colMap[fieldName]!=='local')
          currRow[gridField] = {
           ...row[gridField],
            value: issueObj[row.id]? issueObj[row.id][fieldName] : "",
          };
        } else {
          currRow[gridField] = row[gridField];
        }
      });
      formattedRows.push(currRow);
    }    
  });

  return {rows:formattedRows};
};